import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  card: {
    borderRadius: 20,
    padding: "12px 10px 20px 10px",
    backgroundColor: "#FFF",
    border: "2px solid #E5E5E5",
  },
  cardHdng: {
    fontFamily: "Inter",
    fontSize: 24,
    fontWeight: 700,
    color: "#000",
    padding: "3px 10px 15px 10px",
    borderBottom: "1px solid #D4D4D4",
    margin: 0,
  },
  infoWrapper: {
    flexDirection: "column",
    gap: 10,
    marginBlock: 20,
    paddingInline: 10,
  },
  label: {
    margin: 0,
    fontFamily: "Inter",
    fontSize: 20,
    fontWeight: 700,
    color: "#000",
  },
  labelValueWrapper: {
    gap: 5,
    alignItems: "center",
  },
  value: {
    margin: 0,
    fontFamily: "Inter",
    fontSize: 20,
    fontWeight: 400,
    color: "#000",
  },

  btnWrapper: {
    borderTop: "1px solid #E5E5E5",
    paddingTop: 20,
    display: "flex",
    alignItems: "center",
    gap: 12,
    paddingInline: 10,
  },
  downloadBtn: {
    width: "100%",
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: 600,
    backgroundColor: "#FFAF4A",
    border: "1px solid #FFAF4A",
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: 60,
    color: "#171717",
    "&:hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  viewBtn: {
    width: "100%",
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: 600,
    backgroundColor: "#F5F5F5",
    border: "1px solid #F5F5F5",
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: 60,
    color: "#262626",
    "&:hover": {
      backgroundColor: "#F5F5F5",
      opacity: 0.8,
    },
  },

  // ******** drawer style ************8
  downloadPdfBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #D0D5DD",
    backgroundColor: "#F9FAFB",
    height: 44,
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#F9FAFB",
      opacity: 0.8,
    },
  },
  contentBox: {
    width: "100%",
    padding: "20px",
    borderRadius: 16,
    border: "1px solid #E5E5E5",
    backgroundColor: "#FFF",
  },
  summaryBox: {
    borderRadius: 20,
    border: "2px solid #E5E5E5",
    backgroundColor: "#FAFAFA",
    padding: "12px 18px 20px 18px",
  },
  summaryHdng: {
    color: "#000",
    fontSize: 20,
    fontWeight: 700,
    fontFamily: "Inter",
    margin: 0,
    padding: 10,
    borderBottom: "1px solid #D4D4D4",
  },
  summaryInfoParent: {
    marginBlock: "22px 30px",
    flexDirection: "column",
    gap: 15,
    paddingInline: 10,
  },
  infoLabel: {
    fontSize: 20,
    fontWeight: 700,
    fontFamily: "Inter",
    color: "#000",
    margin: 0,
  },
  infoValue: {
    fontSize: 20,
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#000",
    margin: 0,
  },
}));

export default useStyles;
